import { render, staticRenderFns } from "./IamInterestedIn.vue?vue&type=template&id=c82e6dac&scoped=true&"
import script from "./IamInterestedIn.vue?vue&type=script&lang=ts&"
export * from "./IamInterestedIn.vue?vue&type=script&lang=ts&"
import style0 from "./IamInterestedIn.vue?vue&type=style&index=0&id=c82e6dac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82e6dac",
  null
  
)

export default component.exports